import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Footer({ dark }) {
  const navigate = useNavigate();

  const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

  const goHome = (hash) => {
    navigate('/');
    setTimeout(() => scrollTo(hash), 120);
  };

  const links = [
    { label: 'About Us',         action: () => goHome('#about') },
    { label: 'What We Do',       action: () => goHome('#services') },
    { label: 'Greenhouse Tech',  action: () => goHome('#greenhouse') },
    { label: 'Sustainability',   action: () => goHome('#sustainability') },
    { label: 'Vision & Mission', action: () => goHome('#vision') },
    { label: 'Blog',             action: () => { navigate('/blog'); window.scrollTo({ top: 0, behavior: 'smooth' }); } },
  ];

  return (
    <footer className="bg-[#0d1f10] pt-16 pb-8 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <button
              onClick={() => { navigate('/'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className="flex items-center gap-2.5 mb-4"
            >
              <div className="w-9 h-9 bg-green-700 rounded-lg flex items-center justify-center">
                           <img src="/gloobal exclusive ariel farm logo.png" alt="GEA Farm Logo" className="w-6 h-6" />

              </div>
              <span className="font-serif font-bold text-white text-base">GEA Farm</span>
            </button>
            <p className="text-sm leading-relaxed max-w-xs" style={{ color: '#6a9460' }}>
              A professionally managed agricultural enterprise committed to sustainable food production, innovation, and long-term value through modern greenhouse farming.
            </p>
          </div>

          {/* Nav Links */}
          <div>
            <h4 className="text-xs font-semibold text-white tracking-widest uppercase mb-5">Navigate</h4>
            <ul className="flex flex-col gap-2.5">
              {links.map(item => (
                <li key={item.label}>
                  <button
                    onClick={item.action}
                    className="text-sm transition-colors duration-200 hover:text-green-400 text-left"
                    style={{ color: '#6a9460' }}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Values */}
          <div>
            <h4 className="text-xs font-semibold text-white tracking-widest uppercase mb-5">Our Values</h4>
            <ul className="flex flex-col gap-2.5">
              {['Sustainability', 'Quality & Excellence', 'Innovation', 'Integrity', 'Partnership & Growth'].map(v => (
                <li key={v}><span className="text-sm" style={{ color: '#6a9460' }}>{v}</span></li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t pt-6 flex flex-wrap justify-between items-center gap-4" style={{ borderColor: 'rgba(255,255,255,0.07)' }}>
          <span className="text-xs" style={{ color: '#3d5e3f' }}>
            © {new Date().getFullYear()} Global Exclusive Ariel Farm Ltd. All rights reserved.
          </span>
          <span className="text-xs" style={{ color: '#3d5e3f' }}>
            Growing quality. Sustaining the future.
          </span>
        </div>
      </div>
    </footer>
  );
}
